import React from 'react'
import { Box, Button } from '@mui/material'
import images from 'assets/images'
import { URL_HOME } from 'helpers/config'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import SignUpSellerForm from 'components/pages/signup/SignUpSellerForm'
import HighlightChip from 'components/HighlightChip'
import SignupTemplate from 'components/templates/SignupTemplate'
import useRedirectIfLoggedIn from 'hooks/useRedirectIfLoggedIn'
import AdvantagesContainer, { Advantage } from 'components/ui/AdvantagesContainer'
import FullScreenLoading from 'components/ui/FullScreenLoading'

const advantages: Advantage[] = [
  {
    image: images.signUpSeller.PLUGIN,
    alt: 'Painless listing',
    title: '<strong>Painless</strong> listing',
    text: 'Listing a product takes less than 30 minutes and requires no API integration or other development work.',
  },
  {
    image: images.signUpSeller.PROMOTION,
    alt: 'Amplify your brand',
    title: 'Amplify <strong>your brand</strong>',
    text: 'NachoNacho proactively promotes your product on multiple channels, including social media, and throughout our marketplace.',
  },
  {
    image: images.signUpSeller.ACQUISITION_CHANNEL,
    alt: 'New user acquisition channel',
    title: 'New user <strong>acquisition channel</strong>',
    text: "We'll do all the work and promotions to bring highly qualified buyers directly to you.",
  },
]

const SignUpSeller: React.FC = () => {
  const { loading } = useRedirectIfLoggedIn()

  if (loading) return <FullScreenLoading />

  return (
    <SignupTemplate
      left={
        <>
          <img src={images.LOGO_SYMBOL_BLUE_BACKGROUND} alt="logo" style={{ width: '110px', height: '110px' }} />

          <Box height="30px" />

          <Box>
            <h2 className="text-dark-blue fs-32 fw-700 m-0">The World's Largest</h2>
            <h2 className="text-blue fs-32 fw-700 m-0">B2B SaaS Marketplace</h2>
          </Box>

          <Box my="16px">
            <HighlightChip fontSize="14px">
              Get in front of <strong>300,000+ businesses</strong>
            </HighlightChip>
          </Box>

          <Box maxWidth="393px">
            <p className="m-0 fs-14">
              List your product in the NachoNacho SaaS Marketplace and get discovered by thousands of businesses.
            </p>
          </Box>

          <Box height="54px" />

          <AdvantagesContainer advantages={advantages} />

          <Box height="41px" />

          <Button href={`${URL_HOME}/seller-meeting`} variant="text" className="fs-14 text-blue">
            Request a video call
            <KeyboardArrowRightIcon className="blue" fontSize="small" sx={{ ml: '3px' }} />
          </Button>
        </>
      }
      right={<SignUpSellerForm />}
    />
  )
}

export default SignUpSeller
